/**
 * Owner: Haselton Baker Risk Group, LLC
 * Product: SP3 - SP3-Portfolio-UI
 * Developer: Mike McGlone <mike@hbrisk.com>
 * Date: 5/12/21
 * Copyright All Rights Reserved
 */
import { get, pick } from 'lodash/fp';
import { connect } from 'react-redux';
import { fetchInventoryIfNotCached, fetchInventories } from 'actions/inventoryCreators';
import { selectAuthUserOrgId } from 'selectors/entities/users';
import getUrlSearchParams from 'support/getUrlSearchParams';
import InventoryPage from './InventoryPage';
import { allSearchParams } from 'constants/searchParams';

const mapStateToProps = (state, ownProps) => {
  const { location, match } = ownProps;
  const { inventoryId, analysisType } = get('params', match);
  const searchParams = getUrlSearchParams(allSearchParams, location);

  return ({
    orgId: selectAuthUserOrgId(state),
    inventoryId,
    analysisType,
    ...searchParams,
  });
};

const mapDispatchToProps = dispatch => ({
  makeFetchInventories: orgId => () => dispatch(fetchInventories(orgId)),
  makeFetchCurrentInventoryDetails: (
    inventoryId,
    analysisType,
    searchParams,
  ) =>
    () => dispatch(fetchInventoryIfNotCached(
      inventoryId,
      analysisType,
      searchParams
    )),
});

const mergeProps = (stateProps, dispatchProps, ownProps) => {
  const { inventoryId, analysisType } = stateProps;
  return ({
    ...stateProps,
    ...ownProps,
    fetchInventories: dispatchProps.makeFetchInventories(stateProps.orgId),
    fetchCurrentInventoryDetails: dispatchProps.makeFetchCurrentInventoryDetails(
      inventoryId,
      analysisType,
      pick(allSearchParams, stateProps),
    ),
  });
};

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(InventoryPage);



// WEBPACK FOOTER //
// ./js/components/pages/Inventory/index.js